import { SelectOption } from '@web-for-marketing/react-ui';

const hearAboutUsOptions: SelectOption[] = [
    { content: 'Search engine', value: 'Search engine' },
    { content: 'Ad', value: 'Ad' },
    { content: 'LinkedIn', value: 'LinkedIn' },
    { content: 'Social media', value: 'Social media' },
    { content: 'Recommended by a colleague', value: 'Recommended by a colleague' },
    { content: 'Blog or publication', value: 'Blog or publication' },
    { content: 'Other', value: 'Other' },
];

export default hearAboutUsOptions;
